import React from "react";
import Slider from "react-slick";
// Import css files for react-slick carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../scss/OurChoice.scss";
const ChoiceCarousel = ({ images, arrows }) => {
    // carousel next arrow icon on the right position
    const NextArrow = ({ onClick }) => {
        return (
            <div className={`${'btn'} ${'nextBtn'}`} onClick={onClick}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-16 w-16"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                </svg>
            </div>
        );
    };
    // carousel previous arrow icon on the left position
    const PrevArrow = ({ onClick }) => {
        return (
            <div className={`${'btn'} ${'prevBtn'}`} onClick={onClick}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-16 w-16"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
                    />
                </svg>
            </div>
        );
    };

    // carousel settings
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        pauseOnHover: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: arrows,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                },
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <div id={`ourChoiceCarouselWrapper`} className="text-center">
            <Slider {...settings}>
                {images.map((image, index) => (
                    <div key={index} className="img_parent inline-block">
                        <img
                            style={{ height: "408px", width: "100%" }}
                            className="object-cover"
                            src={image.img}
                            alt={index}
                        />
                        <div className="overlay">
                            <div className="casual common">MEN's CASUAL</div>
                            <div className="browse common">Browse</div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default ChoiceCarousel;
